export const Loader = () => {
    return (
        <div className="loader__cont flex mt-32">
            <div className="load">
                <div className="flex col center">
                    <div className="flex round-box">
                        <div className="round-logo"></div>
                        <div className="round-logo"></div>
                    </div>
                    <div className="equalizer">
                        <div className="equalizer__box">
                            <div className="line line-1"></div>
                            <div className="line line-2"></div>
                            <div className="line line-3"></div>
                            <div className="line line-4"></div>
                            <div className="line line-5"></div>
                            <div className="line line-6"></div>
                            <div className="line line-7"></div>
                            <div className="line line-8"></div>
                            <div className="line line-9"></div>
                            <div className="line line-10"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}